// Prioridad: variable de entorno → desarrollo (CRA en :3001 habla al backend
// en :3000) → mismo origen (panel compilado servido por el propio backend,
// p.ej. a través del túnel/funnel de internet).
export const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL ||
  (window.location.port === '3001' ? 'http://localhost:3000' : window.location.origin);
